import EventManager from "../../../../manager/event_manager";
import * as ProtoPokerRoom from "../../../table/net/proto/proto_poker_room";
import LoaclStorage from "../../../../manager/local_storage";
import ModelData from "../../../public/model_data";

class GameChatData{

    protected _chatHistory:ProtoPokerRoom.Room.ChatHistory.IChatRecord[]=[];

    static MAX_CNT:number = 100;

    constructor(){
        EventManager.instance.on("Event_Notify_GameChatData", this.receiveGameChatData,this,true);
        EventManager.instance.on("show_emoji_msg",this.addChatData,this,true)
    }

    get chatHistory(){
        return this._chatHistory
    }

    private receiveGameChatData(data:ProtoPokerRoom.Room.ChatHistory){
        return;
        this._chatHistory = [];
        for (let index = 0; index < data.history.length; index++) {
            let chatData = data.history[index];
            if (this.isCanInsert(chatData.chatMsg.msgType)) {
                // this._chatHistory.push(chatData)
                // cc.error('xxx--receiveGameChatData',chatData);
                
            }
        }
        this.spliceData();
    }

    private isCanInsert(msgType:number){
       if(msgType == 1//表情
        || msgType == 2//快捷语音 
        || msgType == 3){//自由聊天
            return true;
        }
        return false;
    }

    private addChatData(data:any,data1:any,isNet:boolean){
        return;
        if (isNet) {
            if (data1 && this.isCanInsert( data1.chatMsg.msgType)) {
                // this._chatHistory.push(data1);
                // cc.error('xxx--addChatData',data1);
                this.spliceData();
            }
            if (data1.playerId == ModelData.instance.roleData.id
                && data1.chatMsg.msgType == 1) {
                let items = data1.chatMsg.text.split("_");
                if (items) {
                    this.setRecentEmotin(items[2]);
                }
            }
        }
    }

    //获取最近的表情
    getRecentEmotion():string{
        let str = LoaclStorage.getString(ModelData.instance.roleData.id + '_recent_emotion','');
        return str;
    }

    getRecentEmotionArry():Array<string>{
        let str = this.getRecentEmotion();
        if (str.length > 0) {
            let strarry = str.split('|');
            if (strarry.length == 0) {
                return [str];
            }
            return strarry;
        }
        return [];        
    }

    setRecentEmotin(key:string){
         //存储
        let savekeys = this.getRecentEmotionArry();
        for (let i = 0; i < savekeys.length; i++) {
            let oldemotion = savekeys[i];
            if (key == oldemotion) {
                return;
            }
        }

        if (savekeys.length >= 8) {
            savekeys.shift();
        }

        let saveStr = ''
        if (savekeys.length == 0) {
            saveStr = key;
        }else{
            saveStr = savekeys[0];
            for (let i = 1; i < savekeys.length; i++) {
                saveStr += "|"+ savekeys[i];
            }
            saveStr += '|'+key;
        }
        LoaclStorage.setString(ModelData.instance.roleData.id + '_recent_emotion',saveStr)
    }

    private spliceData(){
        let length = this._chatHistory.length;
        if (length > GameChatData.MAX_CNT) {
            this._chatHistory.splice(0,length-GameChatData.MAX_CNT);
        }
    }

    clearChatData(){
        this._chatHistory = [];
    }
}

export let gameChatData = new GameChatData();